
import { Component, Prop, Vue } from "vue-property-decorator";
import { TopTipsTip, TopTipsTips } from "./TopTips";

@Component
export default class TopTips extends Vue {
  /**
   * 提示内容
   */
  @Prop(Array) readonly tips!: TopTipsTips;
  /**
   * 提示标题
   */
  @Prop({ type: String, default: "" }) readonly prefiex!: string;
  /**
   * 是否添加序号
   */
  @Prop({ type: Boolean, default: false }) readonly withNum!: boolean;
  /**
   * 显示多少列
   */
  @Prop({ type: Number, default: 1 }) readonly column!: number;
  /**
   * 提示内容是否居中
   */
  @Prop({ type: Boolean, default: false }) readonly center!: boolean;

  /**
   * 统一tip item类型
   */
  get tipsArr(): TopTipsTip[] {
    if (typeof this.tips === "string")
      return [{ text: this.tips, colorType: "" }];
    else
      return this.tips.map((tip) =>
        typeof tip === "string" ? { text: tip, colorType: "" } : tip
      );
  }
}
